
    import {Component, Prop, Vue, Watch} from "vue-property-decorator";
    import {mapGetters} from "vuex";
    import {GeoCoordinate, GoogleMapsService} from "@/MarketSearch/services/GoogleMapsService";

    @Component({
        name: 'search-bar',
        computed: mapGetters([
            'filteredLocationsCount',
            'mapsAPIKey',
            'map'
        ])
    })
    export default class SearchBar extends Vue {
        @Prop() value: string = '';
        @Prop({default: false}) showClear!: boolean;
        @Prop({default: false}) autoFocus!: boolean;
        private text: string = this.value;
        private mapsAPIKey!: string;
        private filteredLocationsCount!: number;
        private map!: google.maps.Map;
        private googleResults: google.maps.places.AutocompletePrediction[] = [];
        private disabled: boolean;
        private active: boolean = false;

        mounted() {
            this.text = this.value;
        }

        @Watch('value')
        onValueChange() {
            this.text = this.value;
        }

        onKeyDown(event: KeyboardEvent) {
            this.active = true;
            if (event.key.toLowerCase() === 'enter') {
                event.preventDefault();
                this.submitText();
            }
        }

        @Watch('text')
        onTextChanged() {
            if (this.text !== this.value && !this.disabled) {
                this.$emit('input', this.text);
            }

            if(this.disabled) {
                this.disabled = false;
            }
        }

        async onNothingFound() {
           // if (this.filteredLocationsCount > 0 || !this.map) return;
            const gmaps = new GoogleMapsService(this.mapsAPIKey);
            await gmaps.loadApi();
            this.googleResults = await gmaps.find(this.text);
        }

        async clickOnGoogleResult(googleResult: google.maps.places.AutocompletePrediction) {
            const gmaps = new GoogleMapsService(this.mapsAPIKey);
            const result = await gmaps.geoCodePlaceId(googleResult.place_id);
            if (result.length === 0) return;

            const firstResult = result[0];

            const geoGoordinates: GeoCoordinate = {
                lat: firstResult.geometry.location.lat(),
                lng: firstResult.geometry.location.lng()
            }

            this.googleResults = [];
            this.$emit('input', '');
            // this.$emit('submit', '');
            this.disabled = true;
            this.$nextTick(() => this.text = googleResult.description);
            this.$emit('geo-search', geoGoordinates)
        }

        submitText() {
          this.active = false;
      // ToDo some little dirty quickfix
            return this.onNothingFound()
           /* if (this.filteredLocationsCount === 0) {
                return this.onNothingFound()
            }

            this.$emit('submit', this.text);
*/
        }
    }
